import { BookingInfo } from './../../../interfaces/my-reservation.model';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  MatError,
  MatFormField,
  MatOption,
  MatSelect,
} from '@angular/material/select';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { API_PARAMS } from '../../../constants/api.constants';
import {
  AppointmentInfoField,
  BusinessCheckupSettingsRequest,
  personalCheckupSettingsRequest,
} from '../../../interfaces/appointment-info.model';
import { ModifyExamDietDialogModel } from '../../../interfaces/dialogs/modify-exam-diet-dialog.model';
import { AppointmentInfoService } from '../../../services/appointment-info.service';
import { SharedStorageService } from '../../../services/shared-storage.service';
import { ID_LOGIN_TYPE } from '../../../constants/common.constants';

/**
 * 修改健檢餐食dialog組件
 */
@Component({
  selector: 'app-modify-exam-diet-dialog',
  standalone: true,
  imports: [
    TranslatePipe,
    MatButton,
    ReactiveFormsModule,
    MatSelect,
    MatOption,
    FormsModule,
    MatError,
    MatFormField,
    NgClass,
    NgOptimizedImage,
  ],
  templateUrl: './modify-exam-diet-dialog.component.html',
  styleUrl: './modify-exam-diet-dialog.component.scss',
})
export class ModifyExamDietDialogComponent implements OnInit {
  showFormError: boolean = false; // 是否顯示表單錯誤
  breakfasts: Array<AppointmentInfoField> = []; // 早餐選項
  lunches: Array<AppointmentInfoField> = []; // 午餐選項
  breakfast: string = ''; // 早餐
  lunch: string = ''; // 午餐
  form = new FormGroup({
    breakfast: new FormControl('', [Validators.required]), // 早餐
    lunch: new FormControl('', [Validators.required]), // 午餐
  });

  constructor(
    public dialogRef: MatDialogRef<ModifyExamDietDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModifyExamDietDialogModel,
    private appointmentInfoService: AppointmentInfoService,
    private sharedStorageService: SharedStorageService,
    private translateService: TranslateService
  ) {
    //初始化
    this.form.get('breakfast')?.setValue(data.breakfast ?? '');
    this.form.get('lunch')?.setValue(data.lunch ?? '');
  }

    // 是否為個人預約
    get isPersonalReserve(): boolean {
      if(this.sharedStorageService.get('reserveType')){
        //預約流程
        return (
                this.sharedStorageService.get('reserveType') === ID_LOGIN_TYPE.PERSONAL
              );
      }else{
        //會員中心-我的預約
        if(this.sharedStorageService.get('myReservation')?.companyNo){
          //企業
          return false;
        }else{
          //個人
          return true;
        }
      }
    }
    
  ngOnInit(): void {
    //初始化        
    // 取得早餐午餐選項
  if (this.isPersonalReserve) {
  
      // 取得預約檢項
      const sharedStorageExamItemList =
      this.sharedStorageService.get('examItemList') ?? [];
      const newExamItemList = sharedStorageExamItemList.map(item => ({
        examItem: item.examItem,
        examName: item.examName,
        selectFlag: item.selectFlag ?? 0,
      }));
      const userPlanRequest = this.sharedStorageService.get('userPlanRequest');
      const request: personalCheckupSettingsRequest = {
          dataType: API_PARAMS.CHECKUP_SETTINGS_DATATYPE.DIET,
          orgNo: userPlanRequest?.orgNo ?? '',
          gender: userPlanRequest?.gender ?? '',
          idNo: userPlanRequest?.idNo ?? '',
          companyNo: '1150',
          UUID: userPlanRequest?.uuid ?? '',
          examItemList: newExamItemList ?? []
        };
        //個人CB-069
      this.appointmentInfoService.checkupSettings(request).subscribe(res => {
        this.breakfasts = res.data?.breakfastInfos ?? [];
        this.lunches = res.data?.lunchInfos ?? [];
        if(this.lunches&&this.lunches.length>0){
          //如果有午餐，午餐增加必選檢核
          this.form.get('lunch')?.setValidators([Validators.required]);
          this.form.get('lunch')?.updateValueAndValidity();
        }else{
          //如果有午餐，午餐清除必選檢核
        this.form.get('lunch')?.setValidators(null);
        this.form.get('lunch')?.updateValueAndValidity();
    }
    // 抓 API 餐食(從代號找中文)
      const breakfastUno =
        this.sharedStorageService.get('bookingInfo')?.breakfast;
      this.breakfast =
        this.breakfasts.find(item => item.uno === breakfastUno)?.noDesc ?? '';
      const lunchUno = this.sharedStorageService.get('bookingInfo')?.lunch;
      this.lunch =
        this.lunches.find(item => item.uno === lunchUno)?.noDesc ?? '';
    });
  }else{
    console.log("企業預約");
    // 取得預約檢項
    const sharedStorageExamItemList =
      this.sharedStorageService.get('examItemList') ?? [];
    const newExamItemList = sharedStorageExamItemList.map(item => ({
      examItem: item.examItem,
      examName: item.examName
    }));
    // 取得加選檢項
    const sharedStorageAddList =
      this.sharedStorageService.get('addExamItemList')?? [];
    const addList = sharedStorageAddList.map(item => ({
      examItem: item.examItem,
      examName: item.examName
    }));  
    const businessPlanRequest = this.sharedStorageService.get('businessPlanRequest');
    const idLoginRequest = this.sharedStorageService.get('idLoginRequest');//走漸進式登入
    const businessLoginInfo = this.sharedStorageService.get('businessLoginInfo');//走會員登入
    const createMemberRequest = this.sharedStorageService.get('createMemberRequest');//走會員登入
    const bookingInfo = this.sharedStorageService.get('bookingInfo');
    const myReservation = this.sharedStorageService.get('myReservation');
    const request: BusinessCheckupSettingsRequest = {
            dataType: API_PARAMS.CHECKUP_SETTINGS_DATATYPE.DIET,
            companyNo: businessPlanRequest?.companyNo ?? myReservation?.companyNo ??'',
            familyFlag: idLoginRequest?.identity ?? businessLoginInfo?.identity ?? myReservation?.familyFlag ?? '',
            orgNo: businessPlanRequest?.orgNo ?? bookingInfo?.orgNo ?? '',
            gender: businessPlanRequest?.gender ?? createMemberRequest?.gender ?? '',
            idNo: idLoginRequest?.idNo ?? createMemberRequest?.idNo ?? '',
            examItemList: newExamItemList,
            addList: addList,
          };
          console.log('企業檢查request:', request);
          // CB-074
          this.appointmentInfoService
            .businessCheckupSettings(request)
            .subscribe(res => {
              this.breakfasts = res.data?.breakfastInfos ?? [];
            this.lunches = res.data?.lunchInfos ?? [];
            if(this.lunches&&this.lunches.length>0){
              //如果有午餐，午餐增加必選檢核
              this.form.get('lunch')?.setValidators([Validators.required]);
              this.form.get('lunch')?.updateValueAndValidity();
            }else{
              //如果有午餐，午餐清除必選檢核
            this.form.get('lunch')?.setValidators(null);
            this.form.get('lunch')?.updateValueAndValidity();
          }
          // 抓 API 餐食(從代號找中文)
            const breakfastUno =
              this.sharedStorageService.get('bookingInfo')?.breakfast;
            this.breakfast =
              this.breakfasts.find(item => item.uno === breakfastUno)?.noDesc ?? '';
            const lunchUno = this.sharedStorageService.get('bookingInfo')?.lunch;
            this.lunch =
              this.lunches.find(item => item.uno === lunchUno)?.noDesc ?? '';
            });

  }
    
    
    
  }

  // 關閉dialog
  closeDialog() {
    this.dialogRef.close(null);
  }

  // 提交修改
  onSubmit() {
    this.showFormError = true;
    if (this.form.valid) {
      const formValue = this.form.value;

      //重抓一次中文
      this.breakfast =
        this.breakfasts.find(item => item.uno === formValue.breakfast)?.noDesc ?? '';
      this.lunch =
        this.lunches.find(item => item.uno === formValue.lunch)?.noDesc ?? '';

      const submitValue = {
        ...formValue,//代號
        breakfastDesc: this.breakfast,//中文
        lunchDesc: this.lunch,//中文
      };
      console.log("submitValue:",submitValue)
      this.dialogRef.close(submitValue as ModifyExamDietDialogModel);
    }
  }
}
